import { FieldMetadataDetail } from "../../../insa-models";

export default function computeKeyFields(formMetadataDetails: FieldMetadataDetail[]) {
    const keyFields = formMetadataDetails
        .filter((md) => md.IsKey)
        .map((md) => md.FieldName);

    return keyFields
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/utils/keyFields.ts